import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M13 11C13 9.89543 13.8954 9 15 9C16.1046 9 17 9.89543 17 11C17 12.1046 16.1046 13 15 13C13.8954 13 13 12.1046 13 11Z"}},{"tag":"path","attrs":{"fill":"props.filledColor","d":"M23 3V19H19V22H17V19H7V22H5V19H1V3H23ZM15 7C12.7909 7 11 8.79086 11 11C11 13.2091 12.7909 15 15 15C17.2091 15 19 13.2091 19 11C19 8.79086 17.2091 7 15 7ZM9 8H5V10H9V8ZM9 12H5V14H9V12Z"}}]};

const Radio2Filled = Vue.extend<IconProps>({
  name: 'Radio2FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'radio-2-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Radio2Filled;
